import React from 'react';

const StatusBadge = ({ status, size = 'md' }) => {
  const getStatusStyle = (status) => {
    const styles = {
      draft: { bg: '#F3F4F6', text: '#6B7280', label: 'Draft' },
      pending_approval: { bg: '#FEF3C7', text: '#D97706', label: 'Pending Approval' },
      active: { bg: '#D1FAE5', text: '#059669', label: 'Active' },
      on_hold: { bg: '#FEE2E2', text: '#DC2626', label: 'On Hold' },
      completed: { bg: '#DBEAFE', text: '#2563EB', label: 'Completed' },
      cancelled: { bg: '#F3F4F6', text: '#4B5563', label: 'Cancelled' },
      pending: { bg: '#FEF3C7', text: '#D97706', label: 'Pending' },
      in_progress: { bg: '#DBEAFE', text: '#2563EB', label: 'In Progress' },
      delayed: { bg: '#FEE2E2', text: '#DC2626', label: 'Delayed' },
      verified: { bg: '#D1FAE5', text: '#059669', label: 'Verified' },
      approved: { bg: '#D1FAE5', text: '#059669', label: 'Approved' },
      rejected: { bg: '#FEE2E2', text: '#DC2626', label: 'Rejected' },
    };

    return styles[status] || { bg: '#F3F4F6', text: '#6B7280', label: status };
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const style = getStatusStyle(status);

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${sizeClasses[size]}`}
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      {style.label}
    </span>
  );
};

export default StatusBadge;